import { render, staticRenderFns } from "./NotificationHeaderObservations.vue?vue&type=template&id=bbebee94&scoped=true&"
import script from "./NotificationHeaderObservations.vue?vue&type=script&lang=js&"
export * from "./NotificationHeaderObservations.vue?vue&type=script&lang=js&"
import style0 from "./NotificationHeaderObservations.vue?vue&type=style&index=0&id=bbebee94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbebee94",
  null
  
)

export default component.exports